import React from 'react';
import Box from '@material-ui/core/Box';
import Container from '@material-ui/core/Container';

interface TabPanelProps {
  index: number;
  value: number;
  containerStyle?: React.CSSProperties;
}

const TabPanel: React.FC<TabPanelProps> = ({
  children,
  index,
  value,
  containerStyle,
  ...rest
}) => {
  return (
    <Container maxWidth="lg" style={containerStyle}>
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`scrollable-auto-tabpanel-${index}`}
        aria-labelledby={`scrollable-auto-tab-${index}`}
        {...rest}
      >
        {value === index && <Box>{children}</Box>}
      </div>
    </Container>
  );
};

export default TabPanel;
